import { Component, effect, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs';

import { isNil } from '@core/utils/shared-utils';

@Component({
  selector: 'app-update-params',
  templateUrl: './update-params.html',
  styles: ``,
  imports: [TranslatePipe, ReactiveFormsModule]
})
export class UpdateParams {
  private readonly translate = inject(TranslateService);
  private fb = inject(FormBuilder);

  paramsConfig = input<{ name: string; description: string; id: number }>();
  closeModal = output();
  updateParamOutput = output<{
    name: string;
    description: string;
    id: number;
  }>();

  form = this.fb.group({
    name: ['', [Validators.required, Validators.minLength(2)]],
    description: ['', [Validators.required, Validators.minLength(2)]]
  });

  constructor() {
    effect(() => {
      const params = this.paramsConfig();
      if (params) {
        this.form.patchValue({
          name: params.name ?? 'Untitled',
          description: params.description ?? ''
        });
      }
    });
  }

  protected currentLang = toSignal(
    this.translate.onLangChange.pipe(
      filter((value) => !isNil(value)),
      map((value) => value.lang)
    ),
    { initialValue: this.translate.getCurrentLang() }
  );

  onSubmit() {
    if (this.form.valid) {
      const name = this.form.get('name')?.value ?? 'Untitled';
      const description = this.form.get('description')?.value ?? '';
      const id = this.paramsConfig()?.id ?? 0;

      this.updateParamOutput.emit({ name, description, id });
      this.closeModal.emit();
    } else {
      this.form.markAllAsTouched();
    }
  }

  protected onCancel() {
    this.closeModal.emit();
  }

  private readonly translationPrefixKey = 'common.';
  protected readonly cancelKey = this.translationPrefixKey + 'cancel';
  protected readonly submitKey = this.translationPrefixKey + 'submit';
  protected readonly nameKey = this.translationPrefixKey + 'name';
  protected readonly descriptionKey = this.translationPrefixKey + 'description';
}
